import { render, staticRenderFns } from "./ReferenceTemplate.vue?vue&type=template&id=a31cad9e&scoped=true&"
import script from "./ReferenceTemplate.vue?vue&type=script&lang=js&"
export * from "./ReferenceTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceTemplate.vue?vue&type=style&index=0&id=a31cad9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31cad9e",
  null
  
)

export default component.exports